// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".urge-info-time .millisecond,.urge-info-time .urge-info-number{-webkit-font-feature-settings:\"tnum\";font-feature-settings:\"tnum\";font-variant-numeric:tabular-nums;font-family:arial,Helvetica,sans-serif}", ""]);
// Exports
module.exports = exports;
